module.exports = __webpack_public_path__ + "img/3m.0a5a5ed7.svg";